import axios from '../../axios';
import * as models from '../models';

// hyejoo reads word:word as a filter and parens as groups (an unknown
// filter is a 400), while Meili already splits words at those characters,
// so the search matches the same pages.
export function SearchText(text: string): string {
    return text.replaceAll(/[:()]/g, ' ');
}

export async function SearchSitePages(params: { q: string; data: string; max?: number }): Promise<models.SitePage[]> {
    const resp = await axios.get('/v2/sites', {
        params,
    });
    const body = models.SitesHyejooResponse.fromJSON(resp.data);
    return body.results;
}

export async function SitePageCounts(q: string): Promise<Map<string, number>> {
    const resp = await axios.get('/v2/sites', {
        params: {
            filters: 'page',
            filterCounts: true,
            q,
        },
    });
    const body = models.FiltersResponse.fromJSON(resp.data);
    const counts = new Map<string, number>();
    const page = body.filters.get('page');
    if (!page) {
        return counts;
    }
    for (const option of page.options) {
        if (typeof option.value !== 'string') {
            continue;
        }
        counts.set(option.value, option.count);
    }
    return counts;
}
